import FlashCards from './FlashCards';
import FlashCardsOptions from './FlashCardsOptions';
import validateActivity from './validateFlashCards';
// FC-011 item 4: WordAG → FLASH_CARDS (Pick One; word vs misspelling) generation.
import { validateWords, generateActivityFromWords } from './wordAgFlashCards';

// Options exposed in the Make ActivityOptions panel (FC-09). All keys already
// exist in activity-templates/utils/options.js — no parallel options system.
// `optionsArray` stays intact for existing admin defaults/tooling.
// `Options` is the Flash-Cards-local Options renderer consumed by the OptionsTab
// plugin-Options seam; its layout lives entirely in local files.
export default {
  Template: FlashCards,
  Options: FlashCardsOptions,
  validateActivity,
  optionsArray: [
    'delayBeforeNext',
    'showAnswer',
    'randomOrder',
    'fontFamily',
    'fontSize',
    'fontColor',
  ],
  // FC-011 item 4: the WordAG pipeline (actions/flinkMakeActions/wordlists.js) calls
  // these to generate a FLASH_CARDS activity from a Word AG's words. Additive — no
  // other template or shared pipeline behavior is changed.
  validateWords,
  generateActivityFromWords,
};
